import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectedFilterChip } from '../../interfaces/selected-filter-chip.interface';

@Component({
  selector: 'split-selected-filters-chips',
  templateUrl: './split-selected-filters-chips.component.html',
  styleUrls: ['./split-selected-filters-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplitSelectedFiltersChipsComponent {
  @Input() filters: SelectedFilterChip[] = [];
  @Input() showClearAll = false;
  @Output() removeFilter = new EventEmitter<SelectedFilterChip>();
  @Output() clearAll = new EventEmitter<void>();

  trackByKey(_: number, chip: SelectedFilterChip): string {
    return chip.key;
  }

  onRemove(chip: SelectedFilterChip): void {
    this.removeFilter.emit(chip);
  }

  onClearAll(): void {
    this.clearAll.emit();
  }
}
